<template>
    <div class="ccpay-capital">
         <div class="ccpay-capital-header">
                <span @click="back"> 返回</span>
                <span >资金流水</span>
                <span></span>
         </div>
         <div class="ccpay-capital-connect">
              <mt-loadmore
               v-show="data.length>0"
                :top-method="loadTop"
                :bottom-all-loaded="allLoaded"
                :auto-fill="false"
                @top-status-change="handleTopChange"
                ref="loadmore">
              <div class="ccpay-capital-connect-card" v-for="(item,index) in data" :key="index">
                  <p class="ccpay-cap-cd-bew">
                      <span>交易员编号：{{item.userid}} </span>
                      <span :style="{'color':item.source=='BUY'||item.source=='DEPOSIT'?'green':'red'}">
                                {{item.source=='BUY'?'买入':''}}
                                {{item.source=='DEPOSIT'?'充值':''}}
                                {{item.source=='SELL'?'卖出':''}}
                                {{item.source=='WITHDRAW'?'提现':''}}
                                {{item.source=='WITHDRAW_FEE_OUT'||item.source=='WITHDRAW_FEE_IN'?'提现手续费':''}}
                                {{item.source=='MERCHANTS_FEE'?'商户平台费用':''}}
                                {{item.source=='DEALERS_FEE'?'交易员平台费用':''}}
                      </span>
                   
                  </p>
                  <p>订单编号：{{item.orderNo}}</p>
                  <p >数量：<span style="color:#20ABFE">{{parseFloat(Number(item.value))}}  {{item.symbol}}</span></p>
                 <p >余额：<span style="color:#20ABFE">{{parseFloat(Number(item.log_amount))}}  </span></p>
                  <p>创建时间：<span style="color:#20ABFE">{{item.created_time}}</span></p>
              </div>
             <Scroll
                v-show="data.length>0"
                @timer="timer"
                :moreTit="bottomText"
                ref="mychild"
            />
               </mt-loadmore>
                <div v-else style="color: #999;text-align: center;">暂时没有数据哦～</div>
         </div>
    </div>
</template>

<script>
import Scroll from "@/component/scroll";
import { Indicator } from 'mint-ui';
export default {
    components:{
        Scroll
    },
    data(){
        return {
            data:[],
            allLoaded:false,
            topStatus:'',
            curPage:1,
            bottomText:'上拉加载更多...',
            sourceflag:false
        }
    },
    mounted(){
        this.getdata()
    },
    methods:{
        back(){
            this.$router.go(-1)
        },
        getdata(){
             Indicator.open();
            this.$axios.get('/v1/account/amount/td/history?page=1&per_page=10&sortby=id&order=0&type=-1&symbol=USDT')
            .then(res=>{
                 Indicator.close();
                if(res.code==0){
                this.data = res.data
                this.curPage=1
             
                }
            })
        },
        timer(){
            
            this.bottomText= '正在加载...'
            this.onPullingUp()
        },
        onPullingUp(){  
             this.curPage++
             this.$axios.get(`/v1/account/amount/td/history?page=${this.curPage}&per_page=10&sortby=id&order=0&type=-1&symbol=USDT`)
            .then(res=>{
                if(res.code==0){
                     let data = res.data
                    if(data.length==0){
                        this.bottomText= '暂时没有了'
                        this.$refs.mychild.gets();
                   }else{
                       this.bottomText= '加载更多'
                       this.data = this.data.concat(res.data);
                       this.$refs.mychild.get();
                   }
                    // this.data = res.data
                    // console.log(res)
                }
            })
        },
        loadTop(){
            setTimeout(()=>{
                  this.getdata()
                  this.$refs.loadmore.onTopLoaded();
                  this.bottomText= '加载更多'
                  this.$refs.mychild.get();
            },1000)
        },
        handleTopChange(status){
            this.topStatus = status;
        },  
       
    }
}
</script>

<style lang="scss" scoped>
    .ccpay-capital{
        
         min-height: 100%;
         background: #f8f8f8;
         .ccpay-capital-header{ 
                height: 3rem;
                line-height: 3rem;
                width: 100%;
                position: fixed;
                background: white;
                display: flex;
                justify-content: space-between;
                span:nth-of-type(1){
                    margin-left: 1rem
                }
                span:nth-of-type(3){
                    margin-right: 1rem
                }
         }
         .ccpay-capital-connect{
             padding-top: 4rem;
             padding-left:1rem;
             padding-right:1rem;
             .ccpay-capital-connect-card{
                 padding:1rem;
                 margin-bottom: 2rem;
                 p{
                     line-height: 1.8rem;
                 }
                 .ccpay-cap-cd-bew{
                    display: flex;
                    justify-content: space-between;
                     span:nth-of-type(2){
                         color: red;
                     }
                 }
             }
             .ccpay-capital-connect-card:nth-child(odd){
                 background: white;
             } 
             .ccpay-capital-connect-card:nth-child(even){
                 background: #eee;
             } 
             .ccpay-capital-connect-card:hover{
                  background: #eee;
             }
         }
    }
</style>



// WEBPACK FOOTER //
// src/components/my/Capital.vue